import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";
const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}/`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};


export const EssDasbaord = {
   Dashboard_ESS: async (data) => {
      var axiosConfig = createAxiosConfig("Dashboard_ESS", "POST", data);
      return await axios(axiosConfig);
    },
    save_leave_application_temp: async (data) => {
      var axiosConfig = createAxiosConfig("save_leave_application_temp", "POST", data);
      return await axios(axiosConfig);
    },
    getAppliedLeaves: async (data) => {
      var axiosConfig = createAxiosConfig("get_staff_leave_applications", "POST", data);
      return await axios(axiosConfig);
    },
    get_all_reguralize: async (data) => {
      var axiosConfig = createAxiosConfig("get_all_reguralize", "POST", data);
      return await axios(axiosConfig);
    },
    approve_regularize: async (data) => {
      var axiosConfig = createAxiosConfig("approve_regularize", "POST", data);
      return await axios(axiosConfig);
    },
     reject_regularize: async (data) => {
      var axiosConfig = createAxiosConfig("approve_regularize", "POST", data);
      return await axios(axiosConfig);
    },
    send_regularize_applicatoin: async (data) => {
      var axiosConfig = createAxiosConfig("send_regularize_applicatoin", "POST", data);
      return await axios(axiosConfig);
    },
    getStaffApplications: async (data) => {
      var axiosConfig = createAxiosConfig("get_staff_applications", "POST", data);
      return await axios(axiosConfig);
    },

}